import { CLIENT_DASHBOARD } from 'config/client';
import superFetch from 'library/helpers/superFetch';

export const logAccessControlEvent = (data) => {
	// check if error code exist, then change success to false
	superFetch.post('/logs/accessEvent', { ...data, platform: CLIENT_DASHBOARD }).catch((e) => e);
};

// Dummy Org ID 1 provided to bypass the Auth Org Check.
export const logUserActivityEvent = (data) => {
	// check if error code exist, then change success to false
	superFetch.post('/logs/userActivity', { ...data, platform: CLIENT_DASHBOARD }, {}, 1).catch((e) => e);
};
